import { z } from 'zod';

/**
 * Client configuration. Values come from Vite env (VITE_*), which Vite
 * reads from .env files - never hard-coded in a component.
 */
const schema = z.object({
  apiBaseUrl: z.string().default('/api'),
  appName: z.string().default('Hostsailor PM'),
  defaultLocale: z.enum(['en', 'ar']).default('en'),
  supportedLocales: z.array(z.enum(['en', 'ar'])).default(['en', 'ar']),
  pageSize: z.coerce.number().int().positive().default(25),
  staleTimeMs: z.coerce.number().int().nonnegative().default(30_000),
  pollIntervalMs: z.coerce.number().int().nonnegative().default(60_000),
  dateFormat: z.string().default('dd MMM yyyy'),
  timeFormat: z.string().default('HH:mm'),
});

export const config = schema.parse({
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  appName: import.meta.env.VITE_APP_NAME,
  defaultLocale: import.meta.env.VITE_DEFAULT_LOCALE,
  supportedLocales: import.meta.env.VITE_SUPPORTED_LOCALES?.split(','),
  pageSize: import.meta.env.VITE_PAGE_SIZE,
  staleTimeMs: import.meta.env.VITE_STALE_TIME_MS,
  pollIntervalMs: import.meta.env.VITE_POLL_INTERVAL_MS,
  dateFormat: import.meta.env.VITE_DATE_FORMAT,
  timeFormat: import.meta.env.VITE_TIME_FORMAT,
});

export type AppClientConfig = typeof config;
